<script setup>
import HeroSlider from '@/components/home/HeroSlider.vue';
import HomeCategories from '@/components/home/HomeCategories.vue';
import FeaturedDestinations from '@/components/home/FeaturedDestinations.vue';
import TourPackages from '@/components/home/TourPackages.vue';
import WhyUs from '@/components/home/WhyUs.vue';
import HomeTestimonials from '@/components/home/HomeTestimonials.vue';
import BookingCta from '@/components/site/BookingCta.vue';
</script>

<template>
  <main class="site-main">
    <HeroSlider />
    <HomeCategories />
    <FeaturedDestinations />
    <TourPackages />
    <WhyUs />
    <HomeTestimonials />
    <BookingCta />
  </main>
</template>
